import type { CurriculumAudioPlayer } from "@/features/audio";

export const UNAVAILABLE_FOCUS_SOCIAL_AUDIO_PLAYER: CurriculumAudioPlayer = {
  activeVoiceId: null,
  isPlayingPath: () => false,
  playPath: () => Promise.resolve(false),
  stopOwnedVoice: () => undefined
};
